// import package
import React, { useEffect, useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { useDispatch, useSelector } from 'react-redux'

// import component
import CancelOrder from './CancelOrder'

// import action
import { getOrderList } from '../../actions/stakingAction'

const OrderList = () => {
    const dispatch = useDispatch();

    // redux
    const { loader, data } = useSelector(state => state.stakeOrder);

    useEffect(() => {
        getOrderList(dispatch)
    }, [])

    return (
        <div className="dashboard_box">
            <h5 className="dash_subtitle">Current Subscription</h5>
            <div className="stakingSubscription">
                <Scrollbars style={{ width: "100%", height: 175 }}>
                    <ul>
                        {
                            !loader && data && data.length > 0 && data.map((item, key) => {
                                return (
                                    <li key={key}>
                                        <div className="csLeft">
                                            <h3>
                                                <img src={item.currencyImage} alt="" className="img-fluid" /> {item.currencyName}</h3>
                                            <p><span>{item.createdAt}</span> <span className="textDepositGreen">{item.APY}%</span> {/* <span>Auto</span> */}</p>
                                        </div>
                                        <div className="csRight">
                                            <h4>{item.amount} {item.currencySymbol}</h4>
                                            {
                                                item.status == 'active' && <CancelOrder orderData={item} />
                                            }

                                        </div>
                                    </li>
                                )
                            })
                        }
                        {
                            !loader && data && data.length == 0 && <li>No record</li>
                        }
                        {
                            loader && <li>Loading</li>
                        }
                    </ul>
                </Scrollbars>
            </div>
        </div>
    )
}

export default OrderList;